module.exports = __webpack_public_path__ + "img/99.140b8450.jpg";